import type { Location } from 'history'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'

const SIGNIN_PATHS = ['/signin', '/login']
const SIGNUP_PATHS = ['/signup']

const getPageMeta = (
  pathname: string
): { titleId: string; descriptionId?: string } => {
  const normalized = pathname.toLowerCase()
  if (SIGNIN_PATHS.some((p) => normalized.startsWith(p))) {
    return {
      titleId: 'pageTitle.signIn',
      descriptionId: 'pageDescription.signIn',
    }
  }
  if (SIGNUP_PATHS.some((p) => normalized.startsWith(p))) {
    return { titleId: 'pageTitle.registration' }
  }
  return { titleId: 'pageTitle.account' }
}

const usePageTitle = (): { title: string; description?: string } => {
  // react-router-dom's v5 types don't resolve under tsgolint, so `useLocation()`
  // comes back as an error type. Assert the `history` package's own type.
  const { pathname } = useLocation() as Location
  const { formatMessage } = useIntl()
  const { titleId, descriptionId } = getPageMeta(pathname)
  return {
    title: formatMessage({ id: titleId }),
    description: descriptionId
      ? formatMessage({ id: descriptionId })
      : undefined,
  }
}

export default usePageTitle
